import { render, staticRenderFns } from "./FirmFiles.vue?vue&type=template&id=6a1f7a83"
import script from "./FirmFiles.vue?vue&type=script&lang=js"
export * from "./FirmFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports